<script>
    import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
    import {faDiscord, faTiktok, faXTwitter, faYoutube} from "@fortawesome/free-brands-svg-icons";

    const socialLinks = [
        { name: "Discord", url: "https://discord.gg/scprime", icon: faDiscord, color: "#5865F2" },
        { name: "X", url: "https://x.com/gospelofgsd", icon: faXTwitter, color: "#000000" },
        { name: "Youtube", url: "https://www.youtube.com/@reyna-coin", icon: faYoutube, color: "#FF0000"},
        { name: "Tiktok", url: "https://www.tiktok.com/@reyna.coin", icon: faTiktok, color: "#000000"},
    ];
</script>

<section>
    <h2>Join the Community</h2>
    <p>Community is what memes are all about, and we are too! </p>
    <p>You can find our community on a variety of platforms. See the links below!</p>
    <div class="buy-links-container">
        {#each socialLinks as { name, url, icon, color }}
            <div class="buy-link">
                <a href={url} target="_blank" rel="noopener noreferrer" class="buy-button">
                    {#if icon && typeof icon === 'object'}
                        <FontAwesomeIcon icon={icon} style="color: {color};" />
                    {:else if icon && typeof icon === 'string'}
                        <img src={icon} alt={name} class="button-image" />
                    {:else}
                        <span class="button-text" style="color: {color};">{name}</span>
                    {/if}
                </a>
            </div>
        {/each}
    </div>
</section>

<style>
    section {
        min-height: 100vh; /* Full viewport height */
        display: flex;
        flex-direction: column;
        justify-content: center; /* Centers content vertically */
        align-items: center; /* Centers content horizontally */
        padding: 2rem;
        text-align: center;
    }

    h2 {
        font-size: 1.8rem;
        margin-bottom: 1rem;
    }

    p {
        font-size: 18pt;
        line-height: 1.5;
        margin-bottom: 1.5rem;
    }

    .buy-links-container {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
    }

    .buy-button {
        display: flex;

        min-width: 50px;
        align-items: center;
        /*align horizontally*/
        justify-content: center;
        padding: 10px 20px;
        /*background-color: #007bff; !* Customize your button color here *!*/
        color: white;
        border-radius: 50px; /* Rounded look */
        text-decoration: none; /* Remove link underline */
        font-size: 2rem;
        font-weight: 500;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    }

    .buy-button:hover {
        background-color: #0056b3; /* Darken on hover */
        transform: translateY(-2px); /* Lift effect */
        box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.3);
    }

    .button-image {
        width: 24px; /* Adjust size as needed */
        height: 24px;
        margin-right: 8px;
    }

    .button-text {
        display: inline-block;
    }

    label {
        font-size: 1rem;
    }

    input[type="number"] {
        width: 80px;
        padding: 0.3rem;
        font-size: 1rem;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    button {
        padding: 0.5rem 1rem;
        font-size: 1rem;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    button:hover {
        background-color: #0056b3;
    }
</style>
